<template>
  <div class="app flex-row align-items-center">
    <b-modal
      ref="signupModal"
      title="회원가입"
      size="lg"
      hide-footer
    >
      <div class="d-block text-center">
        <h4>
          장학 헌금 기탁서는 회원가입 없이 진행 가능합니다!<br>
          렘넌트만 회원가입해주세요!<br>
          If you are a remnant for the scholaship, please continue following steps.
        </h4>
      </div>
      <b-button
        class="mt-3"
        variant="outline-success"
        block
        @click="signUp()"
      >
        회원가입(Sign-Up)
      </b-button>
      <b-button
        class="mt-2"
        variant="outline-warning"
        block
        @click="goToDonate()"
      >
        기탁하기(Donation)
      </b-button>
      <b-button
        class="mt-2"
        variant="outline-info"
        block
        @click="goToDashboard()"
      >
        처음으로(Mainpage)
      </b-button>
    </b-modal>
    <b-modal
      ref="passwdModal"
      ok-only
      title="이메일 또는 비밀번호 찾기"
      size="lg"
    >
      <h3>가입 이메일 찾기(Find my email)</h3>
      <b-row align-v="center">
        <b-col cols="5">
          <p class="form-group">
            이름(Name):
            <b-form-input
              v-model="name"
            />
          </p>
        </b-col>
        <b-col cols="5">
          <p class="form-group">
            생년월일(Birthday):
            <datepicker2
              id="dateInput"
              v-model="birthday"
              :language="ko"
              :open-date="new Date(seventeenAgo())"
              input-class="form-control"
              format="yyyy-MM-dd"
              width="100%"
            />
          </p>
        </b-col>
        <b-col cols="2">
          <b-button
            variant="warning"
            @click="findMyEmail()"
          >
            <font-awesome-icon
              :icon="['fas', 'search']"
            />
          </b-button>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="12">
          <b-list-group>
            <b-list-group-item
              v-for="(femail, idx) in foundEmails"
              :key="idx"
            >
              Email: {{ femail }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <hr>
      <h3>비밀번호 찾기(Find my password)</h3>
      <div>반드시 가입한 이메일로 장학부 담당자에게 1)이름, 2)생년월일, 3)이메일과 함께 요청해주세요!</div>
      <div>Please send your 1)name, 2)birthday, and 3)signed-in email to the department using your signed-in email!</div>
    </b-modal>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card
              no-body
              class="p-4"
            >
              <b-card-body>
                <b-form>
                  <b-row>
                    <b-col cols="8">
                      <h1>로그인하기</h1>
                    </b-col>
                    <b-col
                      cols="4"
                      class="text-right"
                    >
                      <b-button
                        size="md"
                        variant="success"
                        block
                        @click="goToDonate()"
                      >
                        <strong>장학헌금 기탁서 작성</strong>
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">
                      <p class="text-muted">
                        장학금을 위해 렘넌트는 로그인 해주세요
                      </p>
                    </b-col>
                    <b-col
                      cols="6"
                      class="text-right"
                    >
                      <b-button
                        variant="link"
                        class="px-0"
                        @click="goToSignUp()"
                      >
                        회원가입(Sign Up)
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user" /></b-input-group-text></b-input-group-prepend>
                    <b-form-input
                      ref="email"
                      v-model="email"
                      v-validate.initial="veeEmail"
                      type="text"
                      class="form-control"
                      placeholder="Email"
                      autocomplete="username email"
                      name="email"
                      :state="!errors.has('email')"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock" /></b-input-group-text></b-input-group-prepend>
                    <b-form-input
                      v-model="passwd"
                      v-validate.initial="veePassword"
                      name="password"
                      :state="!errors.has('password') && passwd !== ''"
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      autocomplete="current-password"
                      @keypress.enter="loginCheck()"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="5">
                      <b-button
                        variant="primary"
                        class="px-4"
                        @click="loginCheck()"
                      >
                        로그인<br>(Sign In)
                      </b-button>
                    </b-col>
                    <b-col
                      cols="7"
                      class="text-right"
                    >
                      <b-button
                        variant="link"
                        class="px-0"
                        @click="$refs.passwdModal.show()"
                      >
                        이메일 또는 암호 찾기<br>(Find Email or Password)
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import Datepicker2 from 'vuejs-datepicker'
import { ko } from 'vuejs-datepicker/dist/locale'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
library.add(faSearch)
export default {
  name: 'Login',
  components: { Datepicker2 },
  data: function () {
    return {
      ko: ko,
      foundEmails: [],
      name: '',
      birthday: '',
      email: '',
      passwd: '',
      veePassword: {
        required: true,
        regex: /^([^가-힣]+)$/
      },
      veeEmail: {
        required: true,
        email: true
      }
    }
  },
  mounted () {
    this.$store.commit('clearAll')
    this.$refs.email.focus()
  },
  methods: {
    findMyEmail () {
      this.foundEmails = []
      if (this.name === '' || this.birthday === '') {
        alert('이름과 생년월일 모두 입력해주세요')
        return
      }
      var postArg = {}
      postArg['name'] = this.name
      postArg['birth'] = this.birthday
      api.request('post', '/remnant/findemail', postArg)
        .then(response => {
          let data = response.data
          this.foundEmails = data.email.length > 0 ? data.email : ['없음(Not Found)']
        })
        .catch(error => {
          console.log(error.response.data.msg)
          alert(error.response.data.msg)
        })
    },
    seventeenAgo () {
      let today = new Date()
      var todayYear = today.getFullYear()
      return String(todayYear - 17) + '-01-01'
    },
    goToSignUp () {
      this.$refs.signupModal.show()
    },
    goToDashboard () {
      this.$router.push('/')
    },
    goToDonate () {
      this.$router.push('/donate/regist')
    },
    signUp () {
      this.$router.push('/remnant/regist')
    },
    loginCheck () {
      if (this.errors.has('email') || this.errors.has('password')) {
        alert('이메일, 암호를 알맞게 입력해주세요!')
        return
      }
      var returnPath = this.$router.currentRoute.query.returnPath
      var formData = new FormData()
      formData.append('email', this.email)
      formData.append('passwd', this.passwd)
      formData.append('applyId', api.docId('apply', this.email))
      api.request('post', '/remnant/login', formData)
        .then(response => {
          let data = response.data
          this.$store.commit('setEmail', data.email)
          this.$store.commit('setToken', data.token)
          this.$store.commit('setRefreshToken', data.refresh_token)
          this.$store.commit('setName', data.name.kr)
          this.$store.commit('setAuth', data.auth)
          this.$store.commit('setUpdated', data.updated)
          this.$store.commit('setMobile', data.mobile)
          this.$store.commit('setLongterm', data.longterm)
          this.$store.commit('setProfile', data.photo)
          this.$store.commit('setSubmit', data.submit)
          if (!returnPath) {
            returnPath = 'Dashboard'
          }
          this.$router.replace({ name: returnPath })
        })
        .catch(error => {
          console.log(error)
          alert(error.response.data.error)
        })
    }
  }
}
</script>
